@reference "@glow/tailwind-config/reference.css";

.toggle input[type="checkbox"] {
  @apply w-0;
  @apply h-0;
  @apply hidden;
}

.toggle label {
  @apply cursor-pointer;
  @apply -indent-96;
  @apply w-11;
  @apply h-6;
  @apply bg-neutral-300;
  @apply block;
  @apply rounded-xl;
  @apply relative;
}

.toggle label:after {
  content: "";
  @apply absolute;
  @apply bg-white;
  @apply rounded-xl;
  @apply w-4;
  @apply h-4;
  @apply right-6;
  top: calc(50% - 0.5rem);
  @apply duration-200;
  @apply ease-in;
}

.toggle input:disabled + label {
  @apply cursor-not-allowed;
  @apply opacity-30;
}

.toggle input:checked + label {
  @apply bg-primary-500;
}

.toggle input:checked + label:after {
  @apply absolute;
  @apply w-4;
  @apply h-4;
  @apply right-1;
  top: calc(50% - 0.5rem);
  @apply duration-200;
  @apply ease-in;
}
